export default __webpack_public_path__ + "media/family.bc45c362.svg";